import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import store from './store'
import Router from 'vue-router'
Vue.use(Router)
import router from './routers.js'
import '@/assets/global.less' /*引入公共样式*/
Vue.use(ElementUI);

import VueSuperSlide from 'vue-superslide'
Vue.use(VueSuperSlide)

// 基础组件的自动化全局注册。全局注册的行为必须在根 Vue 实例 (通过 new Vue) 创建之前发生
import './components/index'
import { getBaseToken as getStoredBaseToken, getToken } from '@/axios/cookies'
import { clearUserSession, getStoredUserInfo, hasUserIdentity } from '@/utils/auth'
import { getBaseToken } from '@/utils'
import state from '@/store/state';




Vue.prototype.$store = store
Vue.prototype.$state = state

Vue.prototype.back=function () {
	if (window.history.length <= 1) {
	    this.$router.push({path:'/'})
	    return false
	} else {
	    this.$router.go(-1)
	}
}

Vue.prototype.openUrl=function (url) {
	this.$router.push({path:url})

}

const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  if (to.name) {
    document.title = '天正智选' + ' - ' + to.name
  }

  const token = getToken()
  const baseToken = getStoredBaseToken()
  const loginPath = ['/reset', '/cart', '/coupons', '/orders', '/integralOrders',
    '/integralOrderDetail', '/score', '/scoreDetails', '/integralRecord', '/integralSubmit',
    '/regProgress', '/address', '/baseInfo', '/tobuy']
  const requiresLogin = loginPath.indexOf(to.path) > -1
  const integralOnly = to.matched.some(record => record.meta && record.meta.integralOnly)
  const secondaryOnly = to.matched.some(record => record.meta && record.meta.secondaryOnly)
  const addressOnly = to.matched.some(record => record.meta && record.meta.addressOnly)

  console.log('路由登录态', { path: to.path, hasUserToken: Boolean(token), hasBaseToken: Boolean(baseToken) })

  if (to.path === '/login') {
    next()
    return
  }

  if (!token && requiresLogin) {
    clearUserSession()
    next('/login')
    return
  }

  if (!token && !baseToken) {
    clearUserSession()
    getBaseToken().then(() => {
      next()
    }).catch(error => {
      console.error('基础登录失败', error)
      next()
    })
    return
  }

  if (!requiresLogin) {
    next()
    return
  }

  const userInfoJson = getStoredUserInfo()
  if (!hasUserIdentity(userInfoJson)) {
    clearUserSession()
    next('/login')
    return
  }

  if (integralOnly && Number(userInfoJson.dealerLevel) !== 1) {
    Vue.prototype.$message.warning('当前账号无权访问积分功能')
    next('/baseInfo')
    return
  }
  if (secondaryOnly && Number(userInfoJson.dealerLevel) !== 2) {
    Vue.prototype.$message.warning('当前账号无权访问该功能')
    next('/baseInfo')
    return
  }
  if (addressOnly) {
    const distributor = userInfoJson.distributor || userInfoJson
    const loginName = distributor && distributor.loginName
    const isSecondaryAddress = Number(userInfoJson.dealerLevel) === 2 && Boolean(distributor)
    const isIntegralAddress = Number(userInfoJson.dealerLevel) === 1 && Boolean(loginName) &&
      !loginName.startsWith('504639_') && !loginName.startsWith('139366_')
    if (!isSecondaryAddress && !isIntegralAddress) {
      Vue.prototype.$message.warning('当前账号无权访问收货地址')
      next('/baseInfo')
      return
    }
  }

  next()
})

new Vue({
  render: h => h(App),
  router,
	store
}).$mount('#app')
